import styles from "./TemplatesHomepages.module.css";
import { BetaCarousel, Text } from "@zapier/design-system";
import { components } from "@zapier/api-clients/apis/templates-backend";
import { useTranslations } from "next-intl";

export const UseCasesSection = ({
  categories,
}: {
  categories: components["schemas"]["Category"][];
}) => {
  const t = useTranslations("Sections");
  return (
    <section>
      <Text
        type="PageHeader"
        tag="h2"
        margin="0 0 10px 0"
        className={styles.sectionHeader}
        color="TextDefault"
      >
        {t("useCases")}
      </Text>
      <div className={styles.fullWidthOnMobile}>
        <BetaCarousel
          paddingBottom={1}
          pageGutterWidth={30}
          className={styles.carousel}
        >
          {categories.map((category) => (
            <a
              href={`/templates/${category.slug}`}
              key={category.slug}
              className={styles.categoryLink}
            >
              <Text
                type="ParagraphHeader3"
                color="BackgroundWeaker"
                className={styles.categoryTitle}
              >
                {category.name}
              </Text>
            </a>
          ))}
        </BetaCarousel>
      </div>
    </section>
  );
};
